import { defineStore } from 'pinia';

// 產品方案相關
export default defineStore('routerList Store', {
  state: () => ({
    routeName: '',
    open: [''],
  }),
  actions: {
    // 前往路由
    async routerPush(path) {
      await this.$router.push(`${path}`);
      this.routeName = this.$router.currentRoute._value.name;
    }
  }
})